import gql from 'graphql-tag';
import { kmsClient } from 'api/index';
import { useMutation } from '@apollo/react-hooks';
import { UpdateArticleAsset, UpdateArticleAssetVariables } from './__generated__/UpdateArticleAsset';

const DELETE_ARTICLE_ASSET_MUTATION = gql`
  mutation UpdateArticleAsset($id: ID!, $text: String!) {
    updateArticleAsset(id: $id, text: $text) {
      articleAsset {
        id
        type
        value
      }
      errors
    }
  }
`;

export const useUpdateArticleAssetMutation = () => {
  return useMutation<UpdateArticleAsset, UpdateArticleAssetVariables>(DELETE_ARTICLE_ASSET_MUTATION, {
    client: kmsClient
  });
};
